import * as t from 'io-ts';

export const ProductTokenPayload = t.type({
  'rights.json': t.string,
});

export const ProductRights = t.partial({
  play: t.boolean,
  excerpt: t.boolean,
  display: t.boolean,
  print: t.boolean,
  printPages: t.string,
  copyPercentage: t.number,
});
